import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const explore = ['Esplora i tomi', 'Consulta i protocolli', 'Usa le checklist', 'Analizza gli algoritmi'];
export function Guarantee() {
  return <section className="bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-130" data-mp="24lwzm9lvyt2h">
      <div className="mx-auto w-full max-w-2xl rounded-3xl border border-gold/30 bg-ink-soft p-6 text-center sm:p-9" data-id="element-131" data-mp="29eykqzcoroui">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gold/15" data-id="element-132" data-mp="2echyly5h1zlx">
          <ShieldCheckIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-133" data-mp="2jajhoj2wdyxe" />
        </span>
        <h2 className="mt-4 font-display text-[24px] font-bold leading-tight text-cream sm:text-3xl" data-id="element-134" data-mp="2ociibl796hqn">
          🛡️ Garanzia totale di 7 giorni
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-cream/70" data-id="element-135" data-mp="txg088kja1xr">
          Prova Protocollo Clinico Sicuro completamente senza rischio.
        </p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-136" data-mp="xz1kwg3b7kii">
          {explore.map(item => <li key={item} className="rounded-full border border-ink-line bg-ink px-3 py-1.5 text-[12px] font-semibold text-cream/70" data-id="element-137" data-mp="3sn9if1sly79k">
              {item}
            </li>)}
        </ul>

        <p className="mt-5 text-[14.5px] leading-relaxed text-cream/65" data-id="element-138" data-mp="3dxbos6bwspcz">
          Se nei prossimi 7 giorni ritieni che questo sistema non porti valore
          alla tua pratica clinica… ti restituiamo il 100% del tuo denaro.
        </p>
        <p className="mt-3 text-[13px] font-semibold text-gold" data-id="element-139" data-mp="aglehf9anq5h">
          Senza spiegazioni. Senza moduli complicati. Senza clausole nascoste.
          Ti basta inviarci un’email.
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-140" data-mp="h480vm7x88g">
          <CTAButton label="Provare senza rischio per 7 giorni" data-id="element-141" data-mp="2q6pv5k2nj7mi" />
        </div>
      </div>
    </section>;
}